export default {
  env: "dev",
  mcpUrl: "https://mcp.crossbeam-dev.com",
} as const;
